import { useState } from 'react';
import Card from '../../components/Card';
import ChartState from '../../context/chart/ChartState';
import TradeState from '../../context/trade/TradeState';
import ClosePositionModal from '../../modals/trade/ClosePositionModal';
import EditPositionModal from '../../modals/trade/EditPositionModal';
import PositionSummaryModal from '../../modals/trade/PositionSummaryModal';
import ExchangeChart from './ExchangeChart';
import ExchangeHeader from './ExchangeHeader';
import ExchangeHistory from './ExchangeHistory';
import ExchangeLists from './ExchangeLists';
import ExchangeMarketOptions from './ExchangeMarketOptions';
import ExchangeSwap from './ExchangeSwap';

const Trade = () => {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <ChartState>
            <section id='exchange'>
                <div className='container'>
                    <TradeState>
                        <Card className='exchange-market-options-header'>
                            <ExchangeMarketOptions
                                collapsed={collapsed}
                                setCollapsed={setCollapsed}
                            />
                            <div className='divider' />
                            <ExchangeHeader />
                        </Card>
                        <ExchangeChart marketOptionsCollapsed={collapsed} />
                        <ExchangeSwap />
                    </TradeState>
                    <ExchangeLists />
                    <ExchangeHistory />
                </div>
            </section>
            <ClosePositionModal />
            <EditPositionModal />
            <PositionSummaryModal />
        </ChartState>
    );
};

export default Trade;
